<style>
  p {
    margin-right: 0em;
    /*padding: 0.4em;*/
  }
  section {
  }
  .contents {
  }
</style>

<script>
  import LocationChoiceWidget from './LocationChoiceWidget.svelte';
  import MultipleChoiceWidget from './MultipleChoiceWidget.svelte';
  import SingleChoiceWidget from './SingleChoiceWidget.svelte';
  import {
    config_values,
  } from '../store';
  
  function toggle_open() {
    if ($config_values.panel_open) {
      $config_values.panel_open = false;
    } else {
      $config_values.panel_open = true;
    };
  }
</script>

<section class='vertical'>
  <div class='caption-left horiz-always togglable unselectable' on:click={toggle_open}>
    <p class='big'>Iestatījumi</p>
    <!-- <div class='filler'></div> -->
    {#if $config_values.panel_open}
      <p class='small'>[–]</p>
    {:else}
      <p class='small'>[+]</p>
    {/if}
  </div>
  {#if $config_values.panel_open}
    <div class='contents vertical'>
      <LocationChoiceWidget />
      <MultipleChoiceWidget widget_id='provider'/>
      <MultipleChoiceWidget widget_id='time'/>
      <MultipleChoiceWidget widget_id='param'/>
      <SingleChoiceWidget widget_id='layout'/>
    </div>
  {/if}
</section>
